export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8658.ab68139d.jpg";